module.exports = __webpack_public_path__ + "static/img/bg.78bd11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/bg.png
// module id = IrCM
// module chunks = 0